import { THistoryEntry } from 'pages/History/const';
import { cdmApi } from '.';

const PREFIX = '/history';

const historyApi = cdmApi.injectEndpoints({
    endpoints: (builder) => ({
        getCompanyHistory: builder.query<{ code: number; histories: THistoryEntry[] }, void>({
            query: () => ({ url: `${PREFIX}/`, method: 'get' }),
        }),
    }),
    overrideExisting: false,
});

export const { useLazyGetCompanyHistoryQuery } = historyApi;
